"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSuspendedState = getSuspendedState;
exports.SUSPENSION_REASON_TYPES = exports.SUSPENSION_APPEAL_STATUS = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _portalHealthStates = _interopRequireDefault(require("EmailData/constants/portalHealthStates"));

var SUSPENSION_APPEAL_STATUS = (0, _keyMirror.default)({
  UNINITIATED: null,
  PENDING: null,
  ACCEPTED: null,
  REJECTED: null,
  ERROR: null
});
exports.SUSPENSION_APPEAL_STATUS = SUSPENSION_APPEAL_STATUS;
var SUSPENSION_REASON_TYPES = (0, _keyMirror.default)({
  BLACKLISTING: null,
  BOUNCES: null,
  CANCELLATIONS: null,
  DEFAULT: null,
  EHAWK: null,
  HEALTH_SCORE: null,
  NONPAYMENT: null,
  OVERRIDE: null,
  OVERRIDE_PHISHING: null,
  OVERRIDE_SPAM: null,
  PHISHING: null,
  SPAM: null,
  SPAMTRAP: null,
  UNSUBSCRIBES: null
});
exports.SUSPENSION_REASON_TYPES = SUSPENSION_REASON_TYPES;

function getSuspendedState() {
  return {
    portalId: _hubspot.default.get(),
    overallState: _portalHealthStates.default.SUSPENDED
  };
}